import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import moment from "moment";

import useInterval from "../../hooks/useInterval";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    whiteSpace: "nowrap",
  },
  time: {
    marginLeft: 8,
    fontWeight: "bold",
    fontSize: "1rem",
  },
  date: {
    fontWeight: "bold",
    fontSize: "1rem",
  },
}));

export type ClockProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

function Clock(props: ClockProps) {
  const { className, ...other } = props;

  const classes = useStyles();
  const rootClasses = React.useMemo(
    () => clsx(classes.root, className),
    [className, classes.root]
  );

  const [time, setTime] = React.useState(moment().format("LTS"));
  const [date, setDate] = React.useState(moment().format("L"));
  useInterval(() => {
    setTime(moment().format("LTS"));
    setDate(moment().format("L"));
  }, 1000);

  return (
    <div className={rootClasses} {...other}>
      <span className={classes.date}>{date}</span>
      <span className={classes.time}>{time}</span>
    </div>
  );
}

export default Clock;
